var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgChevroninline = function SvgChevroninline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.244 6.029a1.073 1.073 0 0 1 1.516 0l6.426 6.426a1.073 1.073 0 0 1-1.516 1.516L10 8.301l-5.67 5.667a1.073 1.073 0 0 1-1.516-1.516L9.24 6.025l.004.004Z",
    fill: "#4A4A4A"
  })));
};
export default SvgChevroninline;